/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TClaim, TClaimGroup, TJoin, TNonEmptyArray, TRoleClaim, TTenant } from "../../helpers/utils.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";
import { CommandResult_Claim, ListCommandResult_Claim } from "../../helpers/types.graphql";

export type TGlobal = TClaim
  | TJoin<"tenant", TTenant>
  | TJoin<"roleClaim", TRoleClaim>
  | TJoin<"claimGroup", TClaimGroup>

type TClaimByIdFunctions = { getByID: CommandResult_Claim }
export type TClaimByIdQueries = { claim: TClaimByIdFunctions };
export const claimById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query claimById($id: Guid!) {
    claim {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Claim")}
`;

type TClaimAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_Claim }
export type TClaimAllWithPaginationQueries = { claim: TClaimAllWithPaginationFunctions };
export const claimAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query claimAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    claim {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Claim")}
`;

type TClaimAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_Claim }
export type TClaimAllWithSortedPaginationQueries = { claim: TClaimAllWithSortedPaginationFunctions };
export const claimAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query claimAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    claim {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Claim")}
`;

export const getUserClaimsByModule = () => gql`
query getMyClaimsByModule($idModule: Guid!) {
  claim {
    getMyClaimsByModule(idModule: $idModule) {
      status,
      message,
      errorCode,
      result {
        alias,
        claimGroup {
          alias,
          permissionGroup {
            alias
          }
        }
      }
    }
  }
}
`;